module.exports = __webpack_public_path__ + "img/switzerland-diseases-of-the-nervous-system-male.b8cd777b.png";